import { Link } from 'gatsby'
import React, { useState } from 'react'
import type { ButtonProps } from '../../ui/button/types'
import { buttonClassName } from '../../ui/button/utils'

interface LinkButtonProps {
  title?: string
  href: string
  label: string
  isInverted?: boolean
  isExternal?: boolean
  size?: ButtonProps['size']
  color?: string
  onClick?: () => void
}

export const LinkButton = ({
  title = undefined,
  href,
  label,
  isInverted = false,
  isExternal = false,
  size,
  color,
  onClick = () => undefined,
}: LinkButtonProps) => {
  const [isHover, setIsHover] = useState(false)

  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }
  const classes = buttonClassName({
    color: color || 'primary',
    invert: isInverted,
    size,
  })

  let backgroundColor = color
  const borderColor = color
  let textColor: string | undefined

  if (color && color.length === 7 && color[0] === '#') {
    if (isHover) {
      backgroundColor = 'white'
      textColor = color
    }

    if (!isInverted) {
      backgroundColor = 'white'
      textColor = color
      if (isHover) {
        backgroundColor = color
        textColor = 'white'
      }
    }
  }

  const style = {
    backgroundColor,
    borderColor,
    color: textColor,
  }

  return isExternal ? (
    <a
      title={title || label}
      href={href}
      target="_blank"
      className={classes}
      style={style}
      rel="noreferrer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      {label}
    </a>
  ) : (
    <Link
      title={title || label}
      to={href}
      className={classes}
      style={style}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      {label}
    </Link>
  )
}
